import React from 'react';
//import { useForm } from 'react-hook-form';
//import emailjs from 'emailjs-com';
//import { init, sendForm } from 'emailjs-com';
//init('user_7EnVptUZTS8pWXrRE5uOx');

const Contact = () => {

    /*const { register, watch, errors } = useForm();
    const [contactNumber, setContactNumber] = useState("000000");
    const [statusMessage, setStatusMessage] = useState('');

    const generateContactNumber = () => {
        const numStr = "000000" + (Math.random() * 1000000 | 0);
        setContactNumber(numStr.substring(numStr.length - 6));
    }

    const sendEmail = (e) => {
        e.preventDefault();
        generateContactNumber();
        emailjs.sendForm('default_service', 'template_78dr0ys', e.target, 'user_7EnVptUZTS8pWXrRE5uOx')
        .then((result) => {
            setStatusMessage("Message sent!");
            console.log(result.text);
        }, (error) => {
            setStatusMessage("Failed to send message! Please try again later.");
            console.log(error.text);
        });
    }

    const message = watch('contactMessage') || "";
    const messageCharsLeft = 1500 - message.length;*/

    /*const { register, handleSubmit, watch, errors } = useForm();
    const [contactNumber, setContactNumber] = useState("000000");
    const [statusMessage, setStatusMessage] = useState("Message");
  
    const generateContactNumber = () => {
        const numStr = "000000" + (Math.random() * 1000000 | 0);
        setContactNumber(numStr.substring(numStr.length - 6));
    }

    /*const onSubmit = (data) => {
        // console.log(data);
        generateContactNumber();
        sendForm('default_service', 'template_78dr0ys', '#contact')
          .then(function(response) {
            console.log('SUCCESS!', response.status, response.text);
          }, function(error) {
            console.log('FAILED...', error);
          });
      }*/

      /*const onSubmit = (data) => {
        const statusMessage = document.querySelector('.status-message');
        generateContactNumber();
        // ...
        sendForm('default_service', 'template_78dr0ys', '#contact_form')
          .then(function(response) {
            // ...
            setStatusMessage("Message sent!");
            statusMessage.className = "status-message success";
            setTimeout(()=> {
              statusMessage.className = 'status-message'
            }, 5000)
          }, function(error) {
            // ...
            setStatusMessage("Failed to send message! Please try again later.");
            statusMessage.className = "status-message failure";
            setTimeout(()=> {
              statusMessage.className = 'status-message'
            }, 5000)
          });
      }

    const message = watch('message') || "";
    const messageCharsLeft = 1500 - message.length;*/

    return (
        <section id="contact">

            <div className="row section-intro" data-aos="fade-up">
                <div className="col-twelve">

                    <h5>Contact</h5>
                    <h1>I'd Love To Hear From You.</h1>
                </div> 
            </div>

            <div className="row contact-info" data-aos="fade-up">

                <div className="col-four tab-full">

                    <div className="icon">
                        <i className="icon-pin"></i>
                    </div>

                    <h5>Where to find me</h5>

                    <p>
                        Caracas, Venezuela
                    </p>

                </div>

                <div className="col-four tab-full collapse">

                    <div className="icon">
                        <i className="icon-mail"></i>
                    </div>

                    <h5>Email Me At</h5>

                    <p>mcrojas09@gmail.com</p>

                </div>

                <div className="col-four tab-full">

                    <div className="icon">
                        <i className="icon-phone"></i>
                    </div>

                    <h5>Call Me At</h5>

                    <p>
                        Mobile: (+58) 414 9185500
                    </p>

                </div>
                
            </div>
            
        </section>
    )
}

export default Contact
